import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 120000, // 2 min — LLM calls can take 20-40s
});

// Attach JWT token from localStorage as Authorization fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cavilo_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global 402 handler — show an upgrade prompt and bounce to /pricing
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      try {
        // dynamic import avoids a circular dep
        // eslint-disable-next-line global-require
        const { toast } = require("sonner");
        toast.error(err.response.data?.detail || "Upgrade to Premium to use this feature.");
      } catch {}
      if (!window.location.pathname.startsWith("/pricing")) {
        setTimeout(() => { window.location.href = "/pricing"; }, 1200);
      }
    }
    return Promise.reject(err);
  }
);

export async function downloadFile(content, filename, format) {
  const res = await api.post(
    "/export",
    { content, filename, format },
    { responseType: "blob" }
  );
  const blob = new Blob([res.data]);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.${format}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
